import { useState } from "react";
import { Mark } from "@/city3d/Logo";
import { EmergentBadge } from "@/hud/EmergentBadge";

// The loading screen until the city has drawn. Same markup and classes as the one in public/index.html, which shows
// before any script runs, so the swap to this one can't be seen.
export function Splash({ done = false }) {
  const [gone, setGone] = useState(false);
  if (gone) return null;
  return (
    <div className={`xf-splash${done ? " done" : ""}`} role="status" aria-label="Loading XField" onTransitionEnd={() => done && setGone(true)}>
      <Mark size={88} className="xf-mark" />
      <div className="xf-word">XFIELD</div>
      <div className="xf-bar"><i /></div>
      <div className="xf-note">Building the city</div>
      <EmergentBadge />
    </div>
  );
}
